import { render, staticRenderFns } from "./ContextMenuDragAndDrop.vue?vue&type=template&id=c852e030&scoped=true&"
import script from "./ContextMenuDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./ContextMenuDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuDragAndDrop.vue?vue&type=style&index=0&id=c852e030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c852e030",
  null
  
)

export default component.exports